export enum TipoOperacaoDeEstoque {
  ENTRADA = 'ENTRADA',
  SAIDA = 'SAIDA',
}
